// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p-nGT","top":"styles_top__yfOvP"};